import { useState, useEffect } from "react";
import { Button, Form, Input, Modal, Popconfirm, Select, Row, Col } from "antd";

import area from "../../../data/Location";
import { recordError } from "../../../utils/logService";
import api from '../../../services/commonLookupService'

import {
  CheckboxSwitchery,
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

const AddressDetails = ({
  onCancel,
  visible,
  onModalSubmit,
  isLocal=true,
  selectedAddress = {},
  form
}) => {
  const formName = "AddressForm";
  // const [form] = Form.useForm();
  const { Option } = Select;

  const formItemLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const [defaultSeletectedCountry, setDefaultSeletectedCountry] = useState("South Africa");
  const [countries, setCountry] = useState([
    ...area.countryList.sort(util.setDynamicSort("text")),
  ]);

  const [cityOrTowns, setcityOrTowns] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [districtProvince, setDistrictProvince] = useState([]);
  const [] = useState([]);
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const title = "Address Correction Form"

  useEffect(() => {
    loadLocationLookups();
  }, []);
  useEffect(() => {
    if (!util.isEmpty(selectedAddress) && districtProvince.length > 0) {
      loadAddress();
    } else {
      form.resetFields();
      //Preselect South African if local
      if (isLocal) {
        const selectedCountry = countries.find(
          (record) => record.value === defaultSeletectedCountry
        );

        form.setFieldsValue({ country: selectedCountry.value });
      }
    }
  }, [selectedAddress]);

  const loadLocationLookups = async () => {
    try {
      const response = await api.getDistrictProvinces();
      if (response) {
        const { data } = response;
        setDistrictProvince(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const loadAddress = () => {
    let selected;
    let selectedDistrict;
    let selectedProvince;

    // ? For now only the selection of South Africa is permitted.
    let selectedCountry = countries.find(
        (record) => record.value === defaultSeletectedCountry
      );

    //   form.setFieldsValue({ country: selectedCountry.value });
    if (isLocal) {
        
        selected = districtProvince?.find(
            (record) => record.value == selectedAddress.province
        );
        setDistricts(selected?.districts);
        
        selectedDistrict = selected?.districts?.find(
            (record) => record.value == selectedAddress.district
        );

    } else {
      selectedProvince = selectedAddress.province;
      selectedCountry = countries.find((record) => record.value === selectedAddress.country);
    }

    form.setFieldsValue({
      street: selectedAddress.street,
      cityOrTown: selectedAddress.cityOrTown,
      postalCode: selectedAddress.postalCode,
      x: selectedAddress.x,
      y: selectedAddress.y,
      province: selected,
      district: selectedDistrict,
      country: selectedCountry,
    });
  };

  const onChangeProvince = (selectedKey) => {
    const newProvince = districtProvince?.find((record) => record.key == selectedKey);
    setDistricts(newProvince?.districts);

    form.setFieldsValue({ district: null, province: newProvince});
  };

  const onChangeCountry = (selected) => {

    // In case of local addresses, prevent selection of South Africa
    if (selected != defaultSeletectedCountry) {
        const entity = `${defaultSeletectedCountry}n addresses`
        var msg = util.parseMessage(Messages.INVALID_SELECTION, entity);
        const invalidSelection = `Invalid selection (${selected.toUpperCase()})`
        openNotification(invalidSelection, msg, Notify.WARNING);
        
    }
    
    const selectedCountry = countries.find((record) => record.value === defaultSeletectedCountry);
    form.setFieldsValue({ country: selectedCountry });
  };
  const onChangeDistrict = (selectedKey) => {
    const selectedDistrict = districts.find((record) => record.key == selectedKey);

    form.setFieldsValue({ district: selectedDistrict });
  };

  const onSubmit = (values) => {

    const newValues = { ...values };

    // Invert the selection because a user would've selected true=valid and false=invalid
    newValues.invalid = !values.isvalid; 

    newValues.district = values.district.value;
    newValues.country = values.country.value;
    newValues.province = values.province.value;
    

    delete newValues.isvalid;

    let id = -1;
    
    if (!util.isEmpty(selectedAddress)) {
        newValues.id = selectedAddress.id;
    } else {
        // This should never happen because the Id is always valid, but at least there should be a flag (-1) to show why update fails
        newValues.id = id; 
    }

    onModalSubmit(newValues).then((success) => {
        if (success == true) {
            form.resetFields();
        }
    });
  };

  const onPostalChange = (e) => {
    const { value } = e.target;
    form.setFieldsValue({ postalCode: util.toNumeric(value) });
  };

  const onLatitudeChange = (e) => {
    const { value } = e.target;
    form.setFieldsValue({ x: util.toNumeric(value) });
  };

  const onLongitudeChange = (e) => {
    const { value } = e.target;
    form.setFieldsValue({ y: util.toNumeric(value) });
  };

  const Confirm = () => {
    onCancel();
    if (util.isEmpty(selectedAddress)) {
      form.resetFields();
    }
  };

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
  };

  const onPopCancel = () => {
    if (form.getFieldValue("street") ||
      form.getFieldValue("cityOrTown") ||
      form.getFieldValue("province") ||
      form.getFieldValue("postalCode") ||
      form.getFieldValue("x") ||
      form.getFieldValue("y")) {
      setDisabled(false);
    } 
    else {
      onCancel();
      setDisabled(true);
    }
  };

  const onChecked =(checked)=> {
    // const { checked } = e.target;
    form.setFieldsValue({ isvalid: checked });
    setChecked(checked)
  }

  return (
    <Modal
      title={title}
      onCancel={onCancel}
      open={visible}
      maskClosable={true}
      onOk={() =>
        form
          .validateFields()
          .then((res) => {
            // form.resetFields();
            onSubmit(res);
          })
          .catch((error) => {
            recordError(error);
          })
      }
      footer={[
        <div
          key="address-modal-footer-buttons"
          className="modal-footer-buttons"
        >
          <Popconfirm
            key="2"
            title="Are you sure you want to cancel...you will lose all info entered?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => Confirm()}
            onCancel={onPopCancel}
            disabled={disabled}
          >
            <Button onMouseUp={() => onPopCancel()} style={{ marginLeft: 10 }}>
              Cancel
            </Button>
          </Popconfirm>
          <Button
                key="1"
                type="primary"
                htmlType="submit"
                onSubmit={onSubmit}
                form={formName}
              >
                Save
              </Button>          
        </div>,
      ]}
    >
      <Form
        {...formItemLayout}
        name={formName}
        form={form}
        // layout="horizontal"
        onFinish={onSubmit}
      >
        <>
          <Form.Item
            name="country"
            label="Country"
            rules={[{ required: true, message: "Please select a country" }]}
          >
            <Select onChange={onChangeCountry} defaultValue={defaultSeletectedCountry}>
              {countries?.map((country) => (
                <Option key={country.value}>{country.text}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="province"
            label="Province/State"
            rules={[
              { required: true, message: "Please select a province/state" },
            ]}
          >
            <Select onChange={onChangeProvince}>
              {districtProvince?.map((province) => (
                <Option key={province.key}>{province.value}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="district"
            label="District"
            rules={[{ required: true, message: "Please select a District" }]}
          >
            <Select onChange={onChangeDistrict}>
              {districts?.map((place) => (
                <Option key={place.key}>{place.value}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="cityOrTown"
            label="Town/City"
            rules={[{ required: true, message: "Please enter town/city" }]}
          >
            <Input name="cityOrTown" onBlur={onNameBlur} />
          </Form.Item>

          <Form.Item
            name="street"
            label="Street Address"
            rules={[{ required: true, message: "Please enter street address" }]}
          >
            <Input name="street" onBlur={onNameBlur} />
          </Form.Item>

          <Form.Item
            name="postalCode"
            label="Postal Code"
            rules={[{ required: true, message: "Please enter postal code" }]}
          >
            <Input
              style={{ width: 100 }}
              minLength={4}
              maxLength={6}
              onChange={onPostalChange}
            />
          </Form.Item>
          <Form.Item label="GPS Coordinates" rules={[{ required: true}]}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="x"
                  label="Latitude"
                  // Force vertical layout for this specific item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[{ required: true, message: 'Please input latitude' }]}
                >
                  <Input placeholder="e.g., -25.7479" onChange={onLatitudeChange} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="y"
                  label="Longitude"
                  // Force vertical layout for this specific item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[{ required: true, message: 'Please input longitude' }]}
                >
                  <Input placeholder="e.g., 28.2293" onChange={onLongitudeChange} />
                </Form.Item>
              </Col>
            </Row>
          </Form.Item>
          <Form.Item name="isvalid" label="">
            <span style={{ paddingRight: 10 }}>
              Confirm if this address is valid:
            </span>
            <CheckboxSwitchery onChange={onChecked} checked={checked} />
          </Form.Item>
        </>
      </Form>
    </Modal>
  );
};

export default AddressDetails;